<div class="agpr-formField agpr-linksListField">
    <ul>
        <li
            *ngFor="let link of value; index as i"
            class="agpr-linksListField-linkCard agpr-contextMenu-parent"
            role="group"
            [attr.aria-label]="'PageBuilder.formField.link.ariaLabel' | localize: {type: linkTypesToLabelStrings[link.type]}"
        >
            <!-- Context Menu -->
            <div
                class="agpr-linksListField-linkCard-hoverBorder"
            ></div>
            <div class="agpr-contextMenu top left">
                <agpr-button
                    [id]="id + '_moveUp_' + i"
                    icon="fa-regular fa-arrow-up"
                    tooltip="PageBuilder.briefings.blockIcon.moveUp"
                    tooltipPosition="top"
                    [disabled]="i === 0"
                    (click)="onLinkAction('moveUp', i)"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
                <agpr-button
                    [id]="id + '_moveDown_' + i"
                    icon="fa-regular fa-arrow-down"
                    tooltip="PageBuilder.briefings.blockIcon.moveDown"
                    tooltipPosition="top"
                    [disabled]="i >= value.length - 1"
                    (click)="onLinkAction('moveDown', i)"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </div>
            <div
                class="agpr-contextMenu top right"
            >
                <agpr-button
                    [id]="id + '_delete_' + i"
                    class="agpr-linksListField-contextButton agpr-linksListField-contextButton--topRight agpr-linksListField-contextButton--bottomLeft"
                    icon="fa-regular fa-duotone fa-trash-can"
                    tooltip="PageBuilder.briefings.blockIcon.delete"
                    tooltipPosition="top"
                    (click)="onLinkAction('delete', i)"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </div>

            <!-- Link Card -->
            <agpr-dropdown
                label="PageBuilder.formField.link.linkType"
                [id]="id + '_LINK_TYPE_' + i"
                [(ngModel)]="link.type"
                (ngModelChange)="valueChange()"
                [options]="linkTypesOptions"
                [bindToValue]="true"
            ></agpr-dropdown>
            <agpr-text-input
                class="agpr-linksListField-linkCard-input"
                [id]="id + '_URL_' + i"
                label="PageBuilder.formField.link.url"
                [(ngModel)]="link.url"
                (ngModelChange)="valueChange(link)"
                [required]="true"
                [placeholder]="'PageBuilder.formField.link.urlPlaceholder' | localize"
            ></agpr-text-input>
            <agpr-form-message *ngIf="link.error">
                {{ 'PageBuilder.formField.link.invalidUrl' | localize }}
            </agpr-form-message>
            <agpr-text-input
                class="agpr-linksListField-linkCard-input"
                [id]="id + '_LINK_TEXT_' + i"
                label="PageBuilder.formField.link.text"
                [(ngModel)]="link.text"
                (ngModelChange)="valueChange()"
                [placeholder]="'PageBuilder.formField.link.textPlaceholder' | localize"
            ></agpr-text-input>
        </li>
    </ul>
    <div class="agpr-linksListField-add">
        <agpr-button
            class="agpr-linksListField-add-button"
            [style]="buttonTypes.tertiary"
            [label]="'PageBuilder.formField.button.addLinkText'"
            [tooltip]="value?.length < linkLimit
                ? 'PageBuilder.formField.button.addLinkText'
                : 'PageBuilder.formField.button.maxLinks'"
            [disabled]="value?.length >= linkLimit"
            (click)="addLink()"
        ></agpr-button>
    </div>
</div>
